module.exports = __webpack_public_path__ + "img/shop.cd911264.svg";